import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-763e5dc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "editProfileModal",
  style: {"z-index":"1600"},
  tabindex: "-1",
  "aria-labelledby": "editProfileModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content p-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_5 = { class: "fw-bold fs-5 mb-3 mb-lg-4 text-center" }
const _hoisted_6 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_7 = { class: "mb-lg-5 mb-3 position-relative" }
const _hoisted_8 = { class: "d-flex justify-content-center mb-2" }
const _hoisted_9 = { class: "fw-bold text-center fs-6" }
const _hoisted_10 = { class: "text-center mb-0 fs-7" }
const _hoisted_11 = { class: "content mx-auto" }
const _hoisted_12 = { class: "fs-7 mb-5 text-break break-spaces" }
const _hoisted_13 = { class: "user-info p-3 bg-gray position-relative d-flex justify-content-center align-items-center mx-sm-auto mb-3 mb-lg-5" }
const _hoisted_14 = { class: "w-100 m-0 p-0 mt-3" }
const _hoisted_15 = { class: "d-flex flex-lg-row flex-column text-center text-lg-start" }
const _hoisted_16 = { class: "col-lg-3" }
const _hoisted_17 = { class: "col-lg-9 text-break break-spaces" }
const _hoisted_18 = { class: "d-flex flex-lg-row flex-column text-center text-lg-start" }
const _hoisted_19 = { class: "col-lg-3" }
const _hoisted_20 = { class: "col-lg-9" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "d-flex flex-lg-row flex-column text-center text-lg-start" }
const _hoisted_23 = { class: "col-lg-3" }
const _hoisted_24 = { class: "col-lg-9 text-nowrap" }
const _hoisted_25 = { class: "tag text-white position-absolute d-flex justify-content-center align-items-center" }
const _hoisted_26 = { class: "mb-3 mb-lg-5" }
const _hoisted_27 = { class: "d-flex justify-content-center align-items-center" }

import { computed } from 'vue'
import { useStore } from 'vuex'
import dayjs from 'dayjs'

import Button from '@/components/button/index.vue'
import TimeLine from '@/views/user/account/profile/setting/components/TimeLine.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Avatar from '@/components/avatar/index.vue'

import { translate } from '@/languages/i18n'
import { ACCOUNT_STORE } from '@/store/constants'
import { getWorkingPeriod } from '@/constants/datepicker'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const profileDetail = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.profileDetail)

const handleName = (user_type: string, profileDetail: any, is_deleted_in_30_days: number, available: boolean) => {
  if (user_type === 'alumni') {
    if (is_deleted_in_30_days === 0) {
      if (!available) return profileDetail?.family_name + ' ' + profileDetail?.given_name + ' ' + '[一時停止]'
      return profileDetail?.family_name + ' ' + profileDetail?.given_name
    } else if (is_deleted_in_30_days === 1) {
      return profileDetail?.family_name + ' ' + profileDetail?.given_name + ' ' + '[脱退済み]'
    } else {
      return '脱退済みユーザ'
    }
  }
}

const isAlumni = computed(() => profileDetail.value?.user_type === 'alumni')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(translate)('profile')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_unref(isAlumni))
              ? (_openBlock(), _createBlock(Avatar, {
                  key: 0,
                  class: "mb-2 icon_avatar cursor-pointer m-auto d-flex",
                  is_deleted_in_30_days: _unref(profileDetail)?.is_deleted_in_30_days,
                  user_image_url: _unref(profileDetail)?.image_url,
                  userType: "alumni"
                }, null, 8, ["is_deleted_in_30_days", "user_image_url"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(UserAliasIcon)
            ]),
            _createElementVNode("h3", _hoisted_9, _toDisplayString(handleName(_unref(profileDetail)?.user_type, _unref(profileDetail), _unref(profileDetail)?.is_deleted_in_30_days, _unref(profileDetail)?.available)), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(profileDetail)?.display_name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(profileDetail).introduction), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(translate)('affiliation')), 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(profileDetail).institution), 1)
              ]),
              _createElementVNode("li", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(translate)('occupation')), 1),
                _createElementVNode("div", _hoisted_20, [
                  (_unref(profileDetail).job_type_child)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(profileDetail).job_type_child), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("li", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(translate)('affiliationPeriod')), 1),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(dayjs)(_unref(profileDetail)?.enrollment_start_period).format('YYYY/M') + ' ' + _unref(translate)('SA20from') + ' ' + _unref(translate)('CI40current')) + " " + _toDisplayString(_unref(getWorkingPeriod)(_unref(profileDetail)?.enrollment_start_period)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(translate)(`SD40currentJob2`)), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(TimeLine)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": 'modal'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})